angular.module('bmsApp.sm.quote')
	.controller('MaterialTestPhotosModalCtrl', function ($scope,
														$modalInstance,
														$q,
														SMMaterialTestPhotoSvc,
														 jobCleaningService,
														 visit) {


		function init() {

			var filters = {};
			if(jobCleaningService){
				filters.JobCleaningService = jobCleaningService.id;
			}
			if(visit){
				filters.Visit = visit.id;
			}
			var promises = {
				beforeMaterialTestPhotos: SMMaterialTestPhotoSvc.index({'filter':angular.extend(filters,{'BeforePhotoOnly':true})}),
				afterMaterialTestPhotos: SMMaterialTestPhotoSvc.index({'filter':angular.extend(filters,{'BeforePhotoOnly':false})}),
			};

			$q.all(promises).then(function(responses) {
				self.beforeMaterialTestPhotos = responses.beforeMaterialTestPhotos.data.material_test_photo_collection;
				self.afterMaterialTestPhotos = responses.afterMaterialTestPhotos.data.material_test_photo_collection;
				self.loading = false;
			});


		}


		function close() {
			$modalInstance.dismiss('cancel');
		}

		var self = $scope.MaterialTestPhotosModalCtrl = {
			beforeMaterialTestPhotos: {},
			afterMaterialTestPhotos: {},
			loading: true,
			processing: false,
			options: {},
			methods: {
				init: init,
				close: close,
			}
		};


	});
